import "./App.css";
import Navbar from "./components/Navbar/Navbar";
import Home from "./components/Home/Home";
import Functions from "./components/Functions/Functions";
import Usage from "./components/Usage/Usage";
import Partners from "./components/Partners/Partners";
// import Statements from "./components/Statements/Statements";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import { LanguageContext } from "./context/LanguageContext";
import { useState, useEffect } from "react";
function App() {
  const [language, setLanguage] = useState("german");

  useEffect(() => {
    const language = localStorage.getItem("language");
    if (language) {
      setLanguage(language);
    }
  }, []);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      <div className="App">
        <Navbar />
        <Home />
        <Functions />
        <Usage />
        <Partners />
        {/* <Statements /> */}
        <Contact />
        <Footer />
      </div>
    </LanguageContext.Provider>
  );
}

export default App;
